export const Questions=[
    {
        prompt:"What is 1+3?",
        optionA:"24",
        optionB:"28",
        optionC:"4",
        optionD:"67",
        answer:"C"
    },
    {
        prompt: "Which of this is not a programming language?",
        optionA: "Python",
        optionB: "JavaScript",
        optionC: "MC-03",
        optionD: "Java",
        answer: "C",
    },
    {
        prompt: "Which of this is not a javascript framework?",
        optionA: "React",
        optionB: "Angular",
        optionC: "Vue",
        optionD: "Java",
        answer: "D",
    }
]